module.exports = __webpack_public_path__ + "static/media/corporate-services-img59.22b80d47.jpg";